<template>
  <div class="user-list">
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="20">
        <el-col :span="8" class="col8">
          <span>用户姓名:</span>
          <el-input placeholder="用户姓名检索" v-model="queryInfo.form.username" clearable @clear="getUserList">
          </el-input>
        </el-col>
        <el-col :span="8" class="col8">
          <span>状态:</span>
          <el-select v-model="queryInfo.form.enableState" placeholder="请选择状态" clearable>
            <el-option v-for="(value,key) in stateMap" :key="key" :label="value" :value="key"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8" class="col8">
          <span>用户ID:</span>
          <el-input v-model="queryInfo.form.id" clearable @clear="getUserList">
          </el-input>
        </el-col>
      </el-row>
      <el-row class="btns">
        <el-button type="primary" v-on:click="getUserList">查询</el-button>
        <el-button type="primary" @click="addDialogVisible = true">新增用户</el-button>

      </el-row>

      <!-- 用户列表区域 -->
      <el-table :data="userList" border stripe>
        <el-table-column label="序号" prop="id" width="50px" type="index" :index="indexMethod"></el-table-column>
        <el-table-column label="用户名称" prop="username"></el-table-column>
        <el-table-column label="角色" prop="roleName"></el-table-column>
        <el-table-column label="手机号码" prop="mobile"></el-table-column>
        <el-table-column label="状态" width="60px">
          <template slot-scope="scope">{{ scope.row.enableState |userStatusMapping}}</template>
        </el-table-column>
        <el-table-column label="性别" width="60px">
          <template slot-scope="scope">{{sexMap[ scope.row.sex]}}</template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">{{ scope.row.createTime |dateFormat}}</template>
        </el-table-column>

        <el-table-column label="操作" width="270px">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
            <!-- 删除按钮 -->
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeById(scope.row.id)">删除</el-button>
            <!-- 分配角色按钮 -->
            <el-tooltip effect="dark" content="角色配置" placement="top" :enterable="false">
              <el-button type="warning" icon="el-icon-setting" size="mini" @click="setRole(scope.row)">配置</el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.page" :page-sizes="[20, 50, 100, 200]" :page-size="queryInfo.size" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <!-- 添加用户的对话框 -->
    <el-dialog title="添加用户" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="formRules" ref="addFormRef" label-width="110px">
        <el-form-item label="昵称" prop="username" class="col2">
          <el-input v-model="addForm.username"></el-input>
          <el-form-item label="手机" prop="mobile">
            <el-input v-model="addForm.mobile"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="密码" prop="password" class="col2">
          <el-input v-model="addForm.password" type="password"></el-input>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="addForm.email"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="状态" prop="enableState" class="col2">
          <el-select v-model="addForm.enableState" placeholder="请选择状态">
            <el-option v-for="(key,val) in stateMap" :key=key :label="key" :value="val"></el-option>
          </el-select>
          <el-form-item label="性别" prop="sex">
            <el-select v-model="editForm.sex" placeholder="请选择状态">
              <el-option v-for="(key,val) in sexMap" :key=key :label="key" :value="val"></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>

        <el-form-item label="头像" prop="user_pic">
          <ul class="header-list">
            <li :class="{'header-item':true,'clicked':addForm.userPic ==i} " v-for=" i in 6" :key='i' @click="selectPic(i,addForm)">
              <img :src="require('../../assets/img/'+i+'.png')" alt="">
              <i class="el-icon-check"></i>
            </li>

          </ul>
        </el-form-item>

      </el-form>

      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUser">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 修改用户信息的对话框 -->
    <el-dialog title="修改用户信息" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
      <el-form :model="editForm" :rules="formRules" ref="editFormRef" label-width="110px">

        <el-form-item label="昵称" prop="username" class="col2">
          <el-input v-model="editForm.username" disabled></el-input>
          <el-form-item label="手机" prop="mobile">
            <el-input v-model="editForm.mobile"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="密码" prop="password" class="col2">
          <el-input v-model="editForm.password" type="password"></el-input>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="editForm.email"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="状态" prop="enableState" class="col2">
          <el-select v-model="editForm.enableState" placeholder="请选择状态">
            <el-option v-for="(key,val) in stateMap" :key=key :label="key" :value="val"></el-option>
          </el-select>
          <el-form-item label="性别" prop="sex">
            <el-select v-model="editForm.sex" placeholder="请选择状态">
              <el-option v-for="(key,val) in sexMap" :key=key :label="key" :value="val"></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>

        <el-form-item label="头像" prop="userPic">
          <ul class="header-list">
            <li :class="{'header-item':true,'clicked':editForm.userPic ==i} " v-for=" i in 6" :key='i' @click="selectPic(i,editForm)">
              <img :src="require('../../assets/img/'+i+'.png')" alt="">
              <i class="el-icon-check"></i>
            </li>
          </ul>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUser">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 分配角色的对话框 -->
    <el-dialog title="分配角色" :visible.sync="setRoleDialogVisible" width="50%" @close="setRoleDialogClosed">
      <div>
        <p>当前的用户：{{userInfo.username}}</p>
        <p>当前的角色：{{userInfo.roleName}}</p>
        <p>分配新角色：
          <el-select v-model="selectedRoleId" placeholder="请选择">
            <el-option v-for="item in rolesList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setRoleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveRoleInfo">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import connomData from '../../common/commonData'
import * as roleApi from '../../api/roleAPI'
import * as userRoleApi from '../../api/userRoleAPI'
import * as userApi from '../../api/userAPI'

import md5 from 'js-md5'
export default {
  data() {
    var validatorPhone = function (rule, value, callback) {
      if (value === '') {
        callback(new Error('手机号不能为空'))
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error('手机号格式错误'))
      } else {
        callback()
      }
    }
    return {
      // 获取用户列表的参数对象
      queryInfo: {
        form: {
          username: '',
          id: '',
          enableState: ''
        },
        // 当前的页数
        page: 1,
        // 当前每页显示多少条数据
        size: 20,
        name: 'tb_user'
      },
      userList: [],
      total: 0,
      // 控制添加用户对话框的显示与隐藏
      addDialogVisible: false,
      setRoleDialogVisible: false,
      percentage: 0,
      // 添加用户的表单数据
      addForm: {
        mobile: '',
        password: '',
        name: '',
        workNumber: '',
        enableState: '2',
        sex: '',
        region: '',
        userPic: '1'
      },
      formRules: {
        username: [{ required: true, message: '昵称不能为空', trigger: "blur", },],
        mobile: [{ required: true, validator: validatorPhone, trigger: "blur", },],
        password: [{ required: true, message: "请输入密码", trigger: "blur", },
        { min: 6, message: '长度需要超过6位', trigger: 'blur' }],
        email: [{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }],
        // workNumber: [{ required: true, message: "请输入工号", trigger: "blur", },],
        enableState: [{ required: true, message: "请选择状态", trigger: "blur", },],

      },
      // 控制修改用户对话框的显示与隐藏
      editDialogVisible: false,
      // 查询到的用户信息对象
      editForm: {
      },
      // 需要被分配角色的用户信息
      userInfo: {},
      // 已选中的角色Id值
      selectedRoleId: '',
      stateMap: { 0: '已失效', 1: "正常", 2: '未登录' },
      sexMap: { 0: '女', 1: "男" },
      areaMap: {},
      rolesList: [],
      userRolesList: []
    }
  },
  created() {
    this.queryInfo.page = Number.parseInt(this.$route.query.page || 1);
    this.queryInfo.size = Number.parseInt(this.$route.query.size || 20);

    this.areaMap = connomData.areaMap;
    this.getUserList()
  },
  methods: {
    async getUserList() {
      let param = { ...this.queryInfo }

      console.log("param", param);
      // delete param.form
      let res = await userApi.list(param)
      if (res.flag) {
        console.log(res);
        this.userList = res.data.list
        this.total = res.data.total
      }

      res = await roleApi.findAll({ form: {}, page: 1, size: 20 })
      if (res.flag) {
        this.rolesList = res.data.list
      }
    },


    // 监听 size 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.size = newSize
      this.getUserList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage)
      this.queryInfo.page = newPage
      this.getUserList()
    },

    // 监听添加用户对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields()
    },
    // 点击按钮，添加新用户
    addUser() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;
        let from = { ...this.addForm }
        let encode = md5(this.addForm.password);
        from.password = md5(this.addForm.password + encode.substring(5, 10))

        userApi.save(from).then(res => {
          if (res.flag) {
            this.$message.success('添加用户成功！')
            this.getUserList()
            this.addDialogVisible = false

          }
        })
      })
    },
    // 展示编辑项目的对话框
    showEditDialog(user) {
      this.editForm = { ...user }
      this.editForm.enableState = user.enableState + ""
      this.editDialogVisible = true
    },
    // 监听修改项目对话框的关闭事件
    editDialogClosed() {
      //this.$refs.addFormRef.resetFields()
      this.editForm = {}
    },
    // 修改信息并提交
    editUser() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;

        let { create_time, ...param } = { ...this.editForm }
        let user = this.userList.find(u => u.id === param.id)
        if (param.password != user.password) {
          let encode = md5(param.password);
          param.password = md5(param.password + encode.substring(5, 10))
        } else {
          delete param.password
        }
        userApi.update(param).then(res => {
          if (res.flag) {
            this.$message.success('更新个人信息成功！')
            this.getUserList()
            this.editDialogVisible = false
          }
        })
      })
    },
    // 根据Id删除对应的项目信息
    async removeById(id) {
      // 弹框询问项目是否删除数据
      const confirmResult = await this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch((err) => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }

      userApi.del(id).then(res => {
        if (res.flag) {
          this.$message.success('删除用户成功！')
          this.getUserList();
        }
      })

    },
    // 监听分配角色对话框的关闭事件
    setRoleDialogClosed() {
      this.selectedRoleId = ''
      this.userInfo = {}
    },
    async saveRoleInfo() {
      let param = { roleId: this.selectedRoleId, }
      param.userId = this.userInfo.id
      let res
      if (this.userInfo.roleId) {
        //param.id = this.userInfo.userRoleId
        res = await userRoleApi.update(param)
      } else {
        res = await userRoleApi.save(param)
      }

      if (res.flag) {
        this.$message.success('修改角色成功！')
        this.getUserList();
        this.setRoleDialogVisible = false
      }
    },
    selectPic(index, form) {
      this.$set(form, 'userPic', index)
      //form.userPic = index
    },
    // 展示分配角色的对话框
    async setRole(userInfo) {
      this.userInfo = userInfo
      this.setRoleDialogVisible = true
    },
       indexMethod(index){
      return (this.queryInfo.page-1)*this.queryInfo.size+index+1
    }

  },
}
</script>

<style lang="less" >
.user-list {
  .col8 {
    display: flex;
    white-space: nowrap;
    align-items: center;
    font-size: 14px;
    color: #606266;
    > span {
      width: 120px;
      text-align: center;
    }
    .el-select {
      width: 100%;
    }
  }
  .btns {
    text-align: end;
    button {
      margin-top: 20px;
    }
  }

  .el-form-item.col2 {
    .el-form-item__content {
      display: flex;
      .el-input {
        width: 230px;
      }
    }
  }
  .el-dialog {
    min-width: 720px;
  }
  .header-list {
    display: flex;
    padding-left: 0px;
    flex-wrap: wrap;
    .header-item {
      margin-left: 20px;
      margin-bottom: 20px;
      padding: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      position: relative;
      box-sizing: border-box;
      img {
        width: 60px;
      }
      .el-icon-check {
        display: none;
      }
    }
    .header-item.clicked {
      border: 2px solid #5fbdfe;
      // ::before {
      //    width:0;
      //   height:0;
      //   border-width:50px;
      //   border-style:solid;
      //   border-top-left-radius: 15px;
      //   opacity: 0.569;
      //   border-color:red transparent transparent red;
      // }
      .el-icon-check {
        display: block;
        position: absolute;
        font-size: 30px;
        font-weight: bolder;
        color: #10ff00;
        bottom: -6px;
        right: -2px;
      }
    }
  }
}
</style>
